import { useTranslation } from 'react-i18next';

import type { FeedingPen, PenWarning } from '@/domain/feedingDashboard';

import type { SystemLabels } from '../systemLabel';

import { PenTagButton } from './PenTagButton';
import { PenWarningMarker } from './PenWarningMarker';
import { penTags } from './penTags';

import styles from './PenComparisonTable.module.scss';

interface PenNameCellProps {
    pen: FeedingPen;
    /** The pen's label, unique within the period; see PenComparisonTable. */
    name: string;
    /** The conditions the pen meets; the marker shows only when there is one. */
    warnings: PenWarning[];
    system: SystemLabels;
}

/** The pinned first cell's content: the pen, its warning marker and its state tags. */
export function PenNameCell(props: PenNameCellProps) {
    const { pen, name, warnings, system } = props;
    const { t } = useTranslation();
    const tags = penTags(pen, t);

    return (
        <div className={styles.penCell}>
            <span>{name}</span>
            {warnings.length > 0 ? <PenWarningMarker warnings={warnings} system={system} /> : null}
            {tags.length > 0 ? (
                <div className={styles.penTags}>
                    {tags.map((tag) => (
                        <PenTagButton key={tag.id} tag={tag} />
                    ))}
                </div>
            ) : null}
        </div>
    );
}
